export const isFormTokensDbAvailable = (): boolean => !!window.indexedDB;
